import { useEffect, useState } from 'react';

/**
 * Персональный выбор видимых пунктов бокового меню — на этом устройстве
 * (localStorage). Хранит СКРЫТЫЕ пункты (чёрный список id), чтобы новые
 * страницы, добавленные позже, по умолчанию были видны.
 *
 * Переключается на странице «Мои настройки» (/me/settings). Sidebar
 * подписывается на изменения через useHiddenNavItems и обновляется сразу
 * (в этой же вкладке — через кастомное событие, в других — через storage).
 */
const KEY          = 'crm.navHidden';    // JSON-массив id скрытых пунктов
const EVENT        = 'crm:navHiddenChange'; // событие для живого обновления в текущей вкладке
const DEFAULT_PAGE = 'crm.defaultPage';  // путь стартовой страницы (напр. '/payments')

export function getHiddenNavItems() {
  try {
    const raw = localStorage.getItem(KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr.filter((x) => typeof x === 'string') : [];
  } catch {
    return [];
  }
}

export function setHiddenNavItems(ids) {
  try {
    const arr = Array.from(new Set((ids || []).filter((x) => typeof x === 'string')));
    localStorage.setItem(KEY, JSON.stringify(arr));
    window.dispatchEvent(new CustomEvent(EVENT));
  } catch {
    /* приватный режим / переполнение — тихо игнорируем */
  }
}

/**
 * Стартовая страница (куда попадаем при заходе на корень `/` и после входа).
 * Хранит путь из меню (напр. '/payments'); пусто = стандартная '/students'.
 * Локально в браузере, как и остальные персональные настройки.
 */
export function getDefaultPage() {
  try {
    return localStorage.getItem(DEFAULT_PAGE) || '';
  } catch {
    return '';
  }
}

export function setDefaultPage(path) {
  try {
    if (path) localStorage.setItem(DEFAULT_PAGE, path);
    else localStorage.removeItem(DEFAULT_PAGE);
  } catch {
    /* игнорируем */
  }
}

/**
 * Реактивный список скрытых пунктов. Возвращает массив id; перерисовывает
 * подписчиков при изменении настройки (в этой или другой вкладке).
 */
export function useHiddenNavItems() {
  const [ids, setIds] = useState(() => getHiddenNavItems());
  useEffect(() => {
    const refresh = () => setIds(getHiddenNavItems());
    window.addEventListener(EVENT, refresh);     // изменения в текущей вкладке
    window.addEventListener('storage', refresh); // изменения в других вкладках
    return () => {
      window.removeEventListener(EVENT, refresh);
      window.removeEventListener('storage', refresh);
    };
  }, []);
  return ids;
}
